export const TASTE_AXES = [
  "Sweet",
  "Sour",
  "Salty",
  "Bitter",
  "Umami",
  "Astringent",
  "Cooling",
  "Pungent",
  "Metallic",
];
